import Vue from 'vue';
export default Vue.extend({
  data: function () {
    return {};
  },
  computed: {
    contributor() {
      return this.params.data.is_contributor == true;
    },
    not_contributor() {
      return this.params.data.is_contributor == false;
    },
  },
  beforeMount() {},
  mounted() {},
  methods: {
    btnClickedHandler(params) {
      this.params.clicked(params.data);
    },
  },
  template: `
  <div>
    <i v-show="contributor" @click="btnClickedHandler(params)" class="fas text-success fa-check" title="Media contributor" style="cursor: pointer;"></i>
    <i v-show="not_contributor" @click="btnClickedHandler(params)" class="fas text-danger fa-times" title="Click to add this user as a media contributor" style="cursor: pointer;"></i>
  </div>
    `,
});
